import { render, staticRenderFns } from "./EventShows.vue?vue&type=template&id=1150b638&lang=pug&"
import script from "./EventShows.vue?vue&type=script&lang=js&"
export * from "./EventShows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports